// noinspection JSUnusedGlobalSymbols

import Environment from '../config/Environment';
import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';

const app = initializeApp({
    apiKey: 'AIzaSyDG51dR98kyWYKzCqoV9PEKE1fDAX5BWF4',
    authDomain: 'kiosk-3d971.firebaseapp.com',
    projectId: 'kiosk-3d971',
    storageBucket: 'kiosk-3d971.appspot.com',
    messagingSenderId: '992524982052',
    appId: '1:992524982052:web:7055c95f3806639f1805b1',
    measurementId: 'G-E17GW60PVF'
});

export const firestore = getFirestore(app);

export const getCollectionPath = (collection) => {
    const environment = Environment.database;
    const client = Environment.client;
    return `kiosk/${environment}/client/${client}/${collection}`;
};